// extracted by mini-css-extract-plugin
export default {"header2":"font-size-module--header2--b5cb1"};